/**
 * gittr.ts - Gittr (Git Management) preferences module
 * 
 * CHANGE HISTORY:
 * - 251031_1600 [pending] danielbeer: Initial creation
 */

export const gittrModule = {
  id: 'infra-gittr',
  name: 'Git Management',
  icon: '🔀',
  category: 'modules',
  order: 23,
  
  packageInfo: {
    name: '@opcentral/gittr',
    version: '0.2.0',
    displayVersion: '0.2.0',
    description: 'Git management system for OpCentral - handles all git operations across the platform',
    status: 'in-progress',
    implementationProgress: 60,
    dependencies: {
      '@opcentral/core': '*',
      '@opcentral/actr': '*',
      '@opcentral/loggr': '*'
    },
    keywords: ['git', 'version-control', 'scm', 'repository'],
    author: 'OpCentral Team',
    license: 'MIT'
  },
  
  settings: {
    autoCommit: {
      type: 'boolean',
      label: 'Auto-Commit',
      description: 'Automatically commit changes',
      defaultValue: false
    },
    
    autoSync: {
      type: 'boolean',
      label: 'Auto-Sync',
      description: 'Automatically push/pull changes',
      defaultValue: false
    },
    
    defaultBranch: {
      type: 'string',
      label: 'Default Branch',
      description: 'Default branch name for new repositories',
      defaultValue: 'main'
    },
    
    commitMessageTemplate: {
      type: 'string',
      label: 'Commit Message Template',
      description: 'Template for auto-generated commit messages',
      defaultValue: '[auto] {action}: {description}'
    }
  }
};

export default gittrModule;
